import React from 'react'
import { IconButton } from '@mui/material'
import useModals from 'src/Hooks/useModals'
import { DeviceInfoForStatement } from 'src/Libs/installation-statement/components/Modals/InstallationStatementDialog'
import { J1RightarrowD } from '@e3dc-react/icons'
import { useTheme } from '@mui/material/styles'

interface Props {
  installation: DeviceInfoForStatement
  disabled?: boolean
}

/**
 * This component is rendered in the Missing Ibn table mobile view (sm).
 * opens the Installation Statement dialog for the selected installation.
 */
const InstallationStatementButtonMobile: React.FC<Props> = ({ installation, disabled = false }) => {
  const { openInstallationStatementDialog } = useModals()
  const theme = useTheme()

  const onButtonClick = (): void => {
    openInstallationStatementDialog({ installation })
  }

  const incompleteStatement = Boolean(installation.installationStatementId)

  return (
    <IconButton onClick={onButtonClick} key={installation.id} color={incompleteStatement ? 'warning' : 'primary'} disabled={disabled}>
      <J1RightarrowD style={{ width: theme.spacing(4), height: theme.spacing(4) }} />
    </IconButton>
  )
}

export default InstallationStatementButtonMobile
